import { ApiRequest, convertDateToUTC } from '@zeal/zeal-lib';
import { ENDPOINTS } from '../endpoints';

export async function listGiftDiscount({ queryKey: [, filters] }: any) {
	return new ApiRequest(ENDPOINTS.giftFriend.discounts.list(filters?.id))
		.addHeader('Accept', 'application/json')
		.GET();
}
export async function createDiscount({
	payload,
	giftId,
}: {
	payload: {
		after_price: number;
		expired_at: string;
	};
	giftId: string;
}) {
	return new ApiRequest(ENDPOINTS.giftFriend.discounts.create(giftId))
		.addHeader('Accept', 'application/json')
		.addHeader('Content-Type', 'application/json')
		.POST(
			JSON.stringify({
				...payload,
				expired_at: convertDateToUTC(payload.expired_at, 'YYYY-MM-DD HH:mm:ss'),
			})
		);
}
export async function updateDiscount({ payload, giftId }: any) {
	return new ApiRequest(ENDPOINTS.giftFriend.discounts.update(giftId))
		.addHeader('Accept', 'application/json')
		.addHeader('Content-Type', 'application/json')
		.POST(JSON.stringify(payload));
}
export async function deleteDiscount(giftId: string) {
	return new ApiRequest(ENDPOINTS.giftFriend.discounts.delete(giftId))
		.addHeader('Accept', 'application/json')
		.addHeader('Content-Type', 'application/json')
		.DELETE();
}
